import { ActionType } from '@wix/ambassador-devcenter-site-apps-v1-app/types';
import { getManageAppsRequiredAction } from '../consts';
export const getRedirectLink = requiredActions => {
  return getActionType(ActionType.EDITOR, requiredActions) || getActionType(ActionType.DASHBOARD, requiredActions);
};
export const getPostInstallRedirectAction = (requiredActions, tenantId) => getRedirectLink(requiredActions) ?? getManageAppsRequiredAction(tenantId);
export const getActionType = (actionType, requiredActions) => requiredActions == null ? void 0 : requiredActions.find(action => action.actionType === actionType);
export const getCreateSiteLink = requiredActions => {
  const requiredAction = getActionType(ActionType.CREATE_SITE, requiredActions);
  return (requiredAction == null ? void 0 : requiredAction.link) || '';
};
export const getDashboardLink = requiredActions => {
  const requiredAction = getActionType(ActionType.DASHBOARD, requiredActions);
  return (requiredAction == null ? void 0 : requiredAction.link) || '';
};
export const getOauthRedirectUrlWithCode = requiredActions => {
  const oauthAction = requiredActions == null ? void 0 : requiredActions.find(requiredAction => requiredAction.actionType === ActionType.OAUTH2);
  return (oauthAction == null ? void 0 : oauthAction.link) || '';
};
//# sourceMappingURL=postInstallation.js.map